import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import {
  getDocFlowMappingNoRecipientNotification,
  isNextPhaseDisabled,
} from '../../DocFlowMapping'
import { useDocFlowContext } from '../useDocFlowContext'

export function useDocFlowMappingHeaderActions({ files, isInitiated }) {
  const { t } = useTranslation()

  const {
    docFlow: {
      has_not_found_splitting_and_mapping_uploading_results:
        hasNotFoundSplittingAndMappingUploadingResults,
      has_not_found_uploading_results: hasNotFoundUploadingResults,
    } = EMPTY_OBJECT,
    isDocFlowLoading,
    setFooterProps,
  } = useDocFlowContext()

  const nextPhaseDisabled =
    isNextPhaseDisabled(files) ||
    hasNotFoundSplittingAndMappingUploadingResults ||
    isDocFlowLoading

  const nextPhaseNotifications = hasNotFoundUploadingResults
    ? [getDocFlowMappingNoRecipientNotification(t)]
    : EMPTY_LIST

  const nextButtonProps = {
    nextPhaseDisabled,
    notifications: nextPhaseNotifications,
    tooltip: hasNotFoundSplittingAndMappingUploadingResults
      ? 'DocFlow.SplittingPhaseHasNoRecipientsNextPhaseDisabledBtnTooltipKey'
      : 'DocumentStapling.SplittingPhaseNextPhaseDisabledBtnTooltipKey',
  }

  useEffect(() => {
    if (isInitiated) {
      setFooterProps(footerProps => ({ ...footerProps, ...nextButtonProps }))
    }
  }, [isInitiated, nextButtonProps])

  return {
    nextButtonProps,
    nextPhaseDisabled,
  }
}
